import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";
export default class CrawlBookingPositionService extends BaseService {
    crawlBookingPosition = (data) => {
        return this.axios.post(API_ENDPOINTS.CRAWL_BOOKING_POSITION, data);
    }
    getCrawlBookingPosition = () => {
        return this.axios.get(API_ENDPOINTS.GET_CRAWL_BOOKING_POSITION);
    }
    deleteInformationStore = (data) => {
        return this.axios.get(API_ENDPOINTS.DELETE_INFORMATION_STORES_BOOKING_POSITION);
    }
    getInformationStore = () => {
        return this.axios.get(API_ENDPOINTS.GET_EXCEL_BOOKING_POSITION);
    }
}